import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { GameDispatcherActions } from "../game/game.actions";
import { switchMap } from "rxjs/operators";
import { EMPTY, of } from "rxjs";
import { displayRequestsAction, removeActiveTab } from "./newMembers.actions";

@Injectable()
export class NewMembersEffects {

    constructor(
        private actions$: Actions,
    ) {}

    createActiveTabProperty$ = createEffect(() => this.actions$.pipe(
        ofType(GameDispatcherActions.addNewGameToState),
        switchMap((action) => {
            if (action.game.componentType === 'game') return of(displayRequestsAction({ gameStateId: action.game.gameStateId }));
            else return EMPTY;
        }),
    ));

    removeActiveTabProperty$ = createEffect(() => this.actions$.pipe(
        ofType(GameDispatcherActions.removeGameFromGamesList),
        switchMap((action) => {
            if (action.removedGame?.componentType === 'game') return of(removeActiveTab({ gameStateId: action.gameStateId }));
            else return EMPTY;
        }),
    ));
}
